import { Controller } from "@hotwired/stimulus"

// Filtrowanie integracji wg kategorii (pills) na stronie /account/apps.
// Gdy wybrana "all", pokazuje wszystkie sekcje kategorii.
// Gdy wybrana konkretna kategoria, pokazuje tylko tę sekcję.
export default class extends Controller {
  static targets = ["pill", "section"]

  connect() {
    this.currentCategory = "all"
  }

  select(event) {
    const category = event.currentTarget.dataset.category
    this.currentCategory = category

    this.pillTargets.forEach(pill => {
      pill.setAttribute("aria-selected", pill.dataset.category === category)
    })

    this.sectionTargets.forEach(section => {
      const show = category === "all" || section.dataset.category === category
      section.classList.toggle("hidden", !show)
    })
  }
}
